var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.5V19.875C2 20.4937 2.5 21 3.11111 21H4.22222C4.83333 21 5.33333 20.4937 5.33333 19.875V18.75H18.6667V19.875C18.6667 20.4937 19.1667 21 19.7778 21H20.8889C21.5 21 22 20.4937 22 19.875V10.875L19.6889 4.13625C19.4667 3.4725 18.8444 3 18.1111 3H9V5.25H17.7111L18.8667 8.625H9V12.5C9 13.072 8.8628 13.6119 8.61953 14.0886C8.41848 14.4826 8.15317 14.8538 7.7066 15.2169C7.10451 15.7065 6.33652 16 5.5 16C3.567 16 2 14.433 2 12.5ZM15.3333 13.6875C15.3333 14.6213 16.0778 15.375 17 15.375C17.9222 15.375 18.6667 14.6213 18.6667 13.6875C18.6667 12.7537 17.9222 12 17 12C16.0778 12 15.3333 12.7537 15.3333 13.6875Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1L6 10.1L8 10.1L5 15L2 10.1L4 10.1L4 1L6 1Z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarEntry);
export default __webpack_public_path__ + "static/media/car-entry.5a10ea3b2d49a2c507239130c17c079d.svg";
export { ForwardRef as ReactComponent };